import React, { useState } from 'react';
import {
    IonCard,
    IonCardContent,
    IonText,
    IonModal,
    IonButton,
    IonIcon,
} from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import QRCode from 'react-qr-code';
import { EventAllocation } from '../../../../models';
import { StatusChip } from './StatusChip';
import './TicketCard.css';

interface TicketCardProps {
    allocation: EventAllocation;
    ticketNumber: number;
}

const TicketCard: React.FC<TicketCardProps> = ({ allocation, ticketNumber }) => {
    const { status, displayName } = allocation;
    const canOpenQr = status === 'confirmed';
    const profileName = allocation.profileName || 'Guest';
    const [qrFullScreen, setQrFullScreen] = useState(false);

    return (
        <>
            <IonCard className="ticket-card">
                <IonCardContent>
                    <div
                        className={`ticket-row${canOpenQr ? '' : ' ticket-row--used'}`}
                        onClick={() => canOpenQr && setQrFullScreen(true)}
                        style={canOpenQr ? { cursor: 'pointer' } : undefined}
                    >
                        <QRCode value={allocation.uuid} size={140} />
                        <div className="ticket-meta">
                            <IonText color="medium">
                                <p className="ticket-number">Ticket #{ticketNumber} {displayName && (<span className="ticket-display-name">- {displayName}</span>)}</p>
                            </IonText>
                            <IonText>
                                <p className="ticket-profile-name">{profileName}</p>
                            </IonText>

                            <StatusChip status={status} />
                        </div>
                    </div>
                </IonCardContent>
            </IonCard>

            <IonModal
                isOpen={qrFullScreen}
                onDidDismiss={() => setQrFullScreen(false)}
                className="qr-fullscreen-modal"
            >
                <div className="qr-fullscreen-container">
                    <div className="qr-fullscreen-back">
                        <IonButton fill="clear" onClick={() => setQrFullScreen(false)}>
                            <IonIcon slot="start" icon={arrowBack} />
                            Back
                        </IonButton>
                    </div>
                    <div className="qr-fullscreen-content">
                        <IonText>
                            <p className="qr-fullscreen-name">{profileName}</p>
                        </IonText>
                        {displayName && (
                            <IonText color="medium">
                                <p className="qr-fullscreen-display-name">{displayName}</p>
                            </IonText>
                        )}
                        <IonText color="medium">
                            <p className="qr-fullscreen-ticket">Ticket #{ticketNumber}</p>
                        </IonText>
                        <div className="qr-fullscreen-code">
                            <QRCode value={allocation.uuid} style={{ width: '100%', height: '100%' }} />
                        </div>
                    </div>
                </div>
            </IonModal>
        </>
    );
};

export default TicketCard;
